/**
 * 根据 id 获取音频封面图的索引，确保图和 id 任何情况下都一一对应
 * @param id 生成物的 id
 * @param totalImages 封面图总数
 * @returns 封面图索引
 */
export const getAudioImageIndex = (id: string, totalImages: number): number => {
  const sum = Array.from(id).reduce((acc, char) => acc + char.charCodeAt(0), 0);
  return sum % totalImages;
};
